<div class="error-area pb-100">
    <div class="container">
        <div class="error-content">
            <img src="assets/images/error.png" alt="Oleev">
            <h3>Page introuvable</h3>
            <p>La page que vous recherchez a été peut-être supprimée, ou elle est temporairement indisponible.</p>
            <a routerLink="/" class="default-btn">Revenir à la page d'accueil</a>
        </div>
    </div>
</div>